import React, { useEffect } from 'react'
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

import Dashboard from './containers/dashboard'
import Login from './containers/login'
import Forgot from './containers/forgot'
import Reset from './containers/reset'
import EmailUpdate from './containers/email-update'
import MicroFrontend from './micro-frontend'
import AuthWrapper from './auth-wrapper'

import { utils, useAppHistory } from 'passiv-libs'

import { LoadingDetails, ModalError } from 'passiv-components'
import RateAppWrapper from './rate-app-wrapper'

// import dummyStore from './tmp/dummy-store'

const Messages = () => <MicroFrontend name="Messages" scriptName="passivliving-messages.min.js" />

const Schedule = () => <MicroFrontend name="Schedule" scriptName="passivliving-schedule.min.js" />

const Heating = () => <MicroFrontend name="Heating" scriptName="passivliving-heating.min.js" />

const Hotwater = () => <MicroFrontend name="Hotwater" scriptName="passivliving-hotwater.min.js" />

const Temperatures = () => (
  <MicroFrontend name="Temperatures" scriptName="passivliving-temperatures.min.js" />
)

const SetupAssistant = () => (
  <MicroFrontend name="SetupAssistant" scriptName="passivliving-setupassistant.min.js" />
)

const Account = () => <MicroFrontend name="Account" scriptName="passivliving-account.min.js" />

const Charts = () => <MicroFrontend name="Charts" scriptName="passivliving-charts.min.js" />

window.__STORE__ = window.__STORE__ || {} // dummyStore

const App = () => {

  useAppHistory()

  // cordova specific - start
  const backButtonHandler = e => {
    if (window.location.hash === '#/' && utils.settings.getPortalWindowStatus()) {
      e.preventDefault()
    } else if (window.location.hash === '#/' || window.location.hash === '#/login') {
      e.preventDefault()
      navigator.app.exitApp()
    } else
      navigator.app.backHistory()
  }

  useEffect(() => {
    document.addEventListener(
      'deviceready',
      () => {
        utils.cordova.hideSplashScreen()
        document.addEventListener('backbutton', backButtonHandler, false)
      },
      false
    )
  }, [])
  // cordova specific - end


  // NB all microapp routes are copied from `{microapp}/src/app.js`
  return (
    <LoadingDetails>
      <Router>
        <AuthWrapper>
          <React.Fragment>
            <ModalError>
              <main className="h-full">
                {/* NB logic to show / hide RateApp is within component */}
                <RateAppWrapper />
                <Switch>
                  {/* ------- App ------- */}
                  <Route exact path="/" component={Dashboard} />
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/forgot" component={Forgot} />
                  {/* DEV-28144: support two routes to forgot page */}
                  <Route exact path="/forgotpwd" component={Forgot} />
                  {/* DEV-28067: For backwards compatability */}
                  <Route exact path="/Reset:passiv" component={Forgot} />
                  {/* ?username=foo&verificationCode=bar */}
                  <Route exact path="/reset" component={Reset} />
                  {/* NB this URL (below) is where users arrive when the email link has forwarded them from:  /r/plc/email/update/passiv/[email]/[code] */}
                  <Route exact path="/email/update/" component={EmailUpdate} />
                  {/* ------- Account ------- */}
                  <Route exact path="/account-and-settings" component={Account} />
                  <Route exact path="/account-and-settings/about" component={Account} />
                  <Route exact path="/account-and-settings/account" component={Account} />
                  <Route exact path="/account-and-settings/schedule" component={Account} />
                  <Route exact path="/account-and-settings/temperatures" component={Account} />
                  <Route exact path="/account-and-settings/thermostats" component={Account} />
                  {/* ------- Charts ------- */}
                  <Route exact path="/charts/:id" component={Charts} />
                  {/* missing second param */}
                  <Redirect from="/charts" to="/" />
                  {/* ------- Messages ------- */}
                  <Route exact path="/messages-and-alerts/view/:view" component={Messages} />
                  <Route
                    exact
                    path="/messages-and-alerts/view/message/id/:id"
                    component={Messages}
                  />
                  {/* missing 'view' */}
                  <Redirect
                    from="/messages-and-alerts/view"
                    to="/messages-and-alerts/view/messages"
                  />
                  {/* missing 'id' */}
                  <Redirect
                    from="/messages-and-alerts/view/message/id"
                    to="/messages-and-alerts/view/messages"
                  />
                  {/* missing 'view' */}
                  <Redirect from="/messages-and-alerts" to="/messages-and-alerts/view/messages" />
                  {/* ------- Schedule ------- */}
                  <Route
                    exact
                    path="/schedule/zone/:zone/day/:day/action/copy"
                    component={Schedule}
                  />
                  <Route
                    exact
                    path="/schedule/zone/:zone/day/:day/action/edit/id/:periodId"
                    component={Schedule}
                  />
                  <Route
                    exact
                    path="/schedule/zone/:zone/day/:day/action/add"
                    component={Schedule}
                  />
                  <Route exact path="/schedule/zone/:zone/day/:day" component={Schedule} />
                  <Route exact path="/schedule/zone/:zone" component={Schedule} />
                  {/* missing 'action' */}
                  <Redirect
                    from="/schedule/zone/:zone/day/:day/action"
                    to="/schedule/zone/:zone/day/:day"
                  />
                  {/* missing 'day' */}
                  <Redirect from="/schedule/zone/:zone/day" to="/schedule/zone/:zone" />
                  {/* missing 'zone' */}
                  <Redirect from="/schedule/zone" to="/schedule/zone/1" />
                  <Redirect from="/schedule" to="/schedule/zone/1" />
                  {/* ------- Heating ------- */}
                  <Route exact path="/heating/zone/:zone" component={Heating} />
                  {/* ------- Hotwater ------- */}
                  <Route exact path="/hotwater" component={Hotwater} />
                  <Route exact path="/hotwater/control" component={Hotwater} />
                  <Route exact path="/hotwater/settings/type/unmonitored" component={Hotwater} />
                  <Route exact path="/hotwater/settings/type/monitored" component={Hotwater} />
                  {/* ------- Temperatures ------- */}
                  <Route exact path="/temperatures/zone/:zone" component={Temperatures} />
                  {/* missing 'zone' */}
                  <Redirect from="/temperatures/zone" to="/temperatures/zone/1" />
                  <Redirect from="/temperatures" to="/temperatures/zone/1" />
                  {/* ------- Setup Assistant ------- */}
                  <Route exact path="/setup-assistant/stage/intro" component={SetupAssistant} />
                  <Route
                    exact
                    path="/setup-assistant/stage/groups/type/:type"
                    component={SetupAssistant}
                  />
                  <Route
                    exact
                    path="/setup-assistant/stage/temperatures"
                    component={SetupAssistant}
                  />
                  <Route
                    exact
                    path="/setup-assistant/stage/schedule/action/:action/type/:type"
                    component={SetupAssistant}
                  />
                  <Route
                    exact
                    path="/setup-assistant/stage/educate/part/:part"
                    component={SetupAssistant}
                  />
                  <Route exact path="/setup-assistant/stage/outro" component={SetupAssistant} />
                  {/* missing action */}
                  <Redirect
                    from="/setup-assistant/stage/schedule/action"
                    to="/setup-assistant/stage/schedule/action/create/type/heating"
                  />
                  <Redirect
                    from="/setup-assistant/stage/schedule"
                    to="/setup-assistant/stage/schedule/action/create/type/heating"
                  />
                  {/* missing stage */}
                  <Redirect from="/setup-assistant/stage" to="/setup-assistant/stage/intro" />
                  <Redirect from="/setup-assistant" to="/setup-assistant/stage/intro" />
                </Switch>
              </main>
            </ModalError>
          </React.Fragment>
        </AuthWrapper>
      </Router>
    </LoadingDetails>
  )
}

export default App
